import { DefaultEdgeOptions, MarkerType } from 'reactflow';

export const defaultEdgeOptions: DefaultEdgeOptions = {
  markerStart: {
    type: MarkerType.ArrowClosed,
  },
};
